import { useRouteMatch } from 'react-router-dom';
import paths from '../../paths';

interface IUseCommunityPageParams {
	communityId: number | null;
	isCommunityHubPage: boolean;
}

export default function useCommunityPageParams(): IUseCommunityPageParams {
	const { params, path } = useRouteMatch();
	const communityId = params.communityId
		? parseCommunityId(params.communityId)
		: null;
	const isCommunityHubPage = path.includes(paths.community());

	function parseCommunityId(string: string) {
		const int = Number(string);
		return isNaN(int) ? null : int;
	}

	return {
		communityId,
		isCommunityHubPage,
	};
}
